import who1 from '../assets/images/GAS/G1.jpg'
import who2 from '../assets/images/GAS/verified.png'
import who3 from '../assets/images/GAS/community.png'
import who4 from '../assets/images/GAS/digital-services.png'
import who5 from '../assets/images/GAS/home.png'
import Gellary from './gellary'

function WhoWe() {
    return (
        <>
            <section className="about-tab-section bg-dark-black text-white pb-120 rpb-100 pt-80 pb-30" id="services">
                <div className="container">
                    <div className="section-title text-center mb-55">
                        <span className="sub-title">WHO WE ARE</span>
                        <h2>Rajeswari Maposi Indane Agency Services</h2>
                    </div>

                    <div className="tab-content about-tab-content">
                        <div className="tab-pane fade show active" id="tabContent1">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="about-image-shape rmb-70 wow fadeInLeft delay-0-2s">
                                        <img className="serviceGas" src={who1} alt="About" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="about-content pr-70 rpr-0 wow fadeInRight delay-0-2s">
                                        <div className="section-title mb-35">
                                            <span className="sub-title">Rajeswari Maposi Indane Agency</span>
                                            <h2 className='textIndand'>Indane Gas Service</h2>
                                        </div>
                                        <p>Looking for a trusted and reliable gas service? Our Indane Gas Agency offers
                                            fast, safe, and efficient LPG solutions for all your cooking needs. With
                                            doorstep delivery, easy refills, and responsive customer support, we ensure your
                                            kitchen never runs out of fuel. Our team is committed to safety and convenience,
                                            providing quality service you can depend on. Choose us for your next refill and
                                            experience seamless, hassle-free service!</p>
                                        <ul className="list-style-one mt-15">
                                            <li>Cylinder Booking</li>
                                            <li>Online Payments</li>
                                            <li>Distributor Locator</li>
                                            <li>Customer Support</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="featured-section bgs-cover pt-240 rpt-150 pb-50 mb-120 rpb-100" id="featured">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-md-8 col-sm-10">
                            <div className="section-title text-center mb-35">
                                <span className="sub-title">WHO WE ARE</span>
                                <h2>Indian Government Services</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-md-6">
                            <div className="feature-item wow fadeInUp delay-0-2s">
                                <div className="icon">
                                    <img className="responseIcon" src={who2} alt="Verified" />
                                </div>
                                <div className="feature-content">
                                    <h5>Compressed Natural Gas</h5>
                                    <p>CNG is an eco-friendly fuel compatible with all four-wheelers through easy kit
                                        installation.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-6">
                            <div className="feature-item wow fadeInUp delay-0-4s">
                                <div className="icon">
                                    <img className="responseIcon" src={who3} alt="Community" />
                                </div>
                                <div className="feature-content">
                                    <h5>Piped Natural Gas</h5>
                                    <p>Domestic customers prefer PNG for its safety, convenience, and eco-friendliness.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-6">
                            <div className="feature-item wow fadeInUp delay-0-6s">
                                <div className="icon">
                                    <img className="responseIcon" src={who4} alt="Digital Services" />
                                </div>
                                <div className="feature-content">
                                    <h5>Natural Gas</h5>
                                    <p>Natural gas, primarily methane, forms from decomposed organic matter in porous
                                        underground rock.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-6">
                            <div className="feature-item wow fadeInUp delay-0-8s">
                                <div className="icon">
                                    <img className="responseIcon" src={who5} alt="Home" />
                                </div>
                                <div className="feature-content">
                                    <h5>No Emission Gas</h5>
                                    <p>Pradhan Mantri Awas Yojana for affordable housing for the urban and rural poor.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Gellary />
        </>
    )
}

export default WhoWe